var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-block',[_c('DxForm',[_c('DxGroupItem',{attrs:{"col-count":_vm.setThreeCols ? 3 : 2}},[_c('DxSimpleItem',{attrs:{"col-span":1,"data-field":_vm.$t('layerOptions_select_index'),"caption":_vm.$t('layerOptions_select_index'),"editor-type":"dxSelectBox","editor-options":{
          items: _vm.indexAvailables,
          value: _vm.currentIndexes[("" + _vm.keyId)],
          placeholder: _vm.$t('layerOptions_index_availables'),
          onValueChanged: _vm.onSelectedIndex,
        }}},[_c('DxRequiredRule',{attrs:{"message":_vm.$t('DxRegisterCampania_end_date_require')}})],1),_vm._v(" "),_c('DxSimpleItem',{attrs:{"col-span":1,"name":"init-date","data-field":_vm.$t('date'),"editor-type":"dxDateBox","editor-options":{
          value: _vm.actualDate,
          onValueChanged: _vm.onChangeInitDate,
          displayFormat: 'dd/MM/yyyy',
          placeholder: _vm.$t('registerClima_initDate_placeholder'),
          invalidDateMessage: _vm.$t('dates_isInvalid'),
          pickerType: 'calendar',
          disabledDates:_vm.disabledDates,
          onInitialized:_vm.init,
          inputAttr:_vm.inputAttr
        }}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }